export default function UserMessageTile({ children, message, className }) {
  const classNames =
    className +
    " bg-white flex h-[404px] flex-1 items-center shadow rounded-md border bg-clip-padding"

  return (
    <div className={classNames}>
      {children ? (
        children
      ) : (
        <div className="mx-12 w-full text-center">{message}</div>
      )}
    </div>
  )
}
